import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-100 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center space-x-3">
            <Logo className="w-8 h-8 opacity-80" />
            <span className="text-sm font-semibold text-slate-900">Valtivo</span>
            <span className="text-slate-300">|</span>
            <span className="text-xs text-slate-500 uppercase tracking-wider">Enterprise Voice Automation</span>
          </div>
          <div className="text-sm text-slate-400">
            <p>&copy; 2026 Valtivo. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;